export default __webpack_public_path__ + "static/media/leahhenseler.c92eddee.jpg";